<template>
<v-container fluid style="max-width: 1280px;">
    <v-overlay :value="searching">
        <v-progress-circular color="black" size="48" indeterminate />
    </v-overlay>

    <v-row no-gutters align="center" justify="space-between">

        <im-title-bar title="Athena Reservations" />

        <im-profile />
    </v-row>

    <v-row no-gutters>
        <v-col cols="12">
            <im-search-bar :place_id.sync="query.place_id" :check_in.sync="query.check_in" :check_out.sync="query.check_out" :rooms.sync="query.rooms" :currency.sync="query.currency" @search="getHotels()" />
        </v-col>
    </v-row>
    <v-row no-gutters>
        <v-col cols="12" v-for="offer in items">
            <im-hotel :item="offer" @click.native="navigateToHotel(offer.hotel.id)" />
        </v-col>
    </v-row>
    <div v-if="no_results" class="d-flex justify-center align-center pt-5 headline">
        Ne pare rau, nu am gasit nici un hotel pentru selectia dvs
    </div>
</v-container>
</template>

<script>
import IMProfile from '@imemento/spa-helpers/src/components/IMProfile/IMProfile.vue';
import TitleBar from "@/components/items/TitleBar";
import SearchBar from "@/components/items/SearchBar";
import Hotel from "@/components/items/Hotel";
import {
    getHotelsByLocationId,
    getStaticHotelsByIds
} from "@/api/Booking";

export default {
    name: 'home',

    components: {
        'im-profile': IMProfile,
        "im-title-bar": TitleBar,
        "im-search-bar": SearchBar,
        "im-hotel": Hotel,
    },

    data() {
        return {
            items: [],
            searching: false,

            no_results: false,

            query: {
                place_id: null,
                check_in: this.$moment()
                    .format('YYYY-MM-DD'),
                check_out: this.$moment()
                    .add(1, 'days')
                    .format('YYYY-MM-DD'),
                rooms: [{
                    adults: [{
                        age: 'a'
                    }],
                    children: []
                }],
                currency: 'RON'
            }

        }
    },

    created() {},

    methods: {

        test() {
            let occupancy = this.query.rooms.map(function (item) {
                let value = item.adults.map(adult => adult.age)
                    .concat(item.children.map(children => children.age));
                return value.join(",")
            })
            console.log(occupancy, this.query.rooms);
        },

        getHotels() {
            let adults = 0;
            let occupancy = this.query.rooms.map(function (item) {
                adults += item.adults.length;
                let value = item.adults.map(adult => adult.age)
                    .concat(item.children.map(children => children.age));
                return value.join(",")
            })
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/athena/v1/search/hotels';

            // setup query params
            let params = {
                params: {
                    place_id: this.query.place_id,
                    check_in: this.query.check_in,
                    check_out: this.query.check_out,
                    // rooms: occupancy.length,
                    // adults: adults,
                    occupancy: occupancy,
                    currency: this.query.currency,
                }
            };
            console.log(params);
            this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.data.length) {
                        this.items = response.data.data;
                        this.no_results = false;
                    } else {
                        this.no_results = true
                    }
                    // console.log("response", response);
                })
                .catch(error => {

                    console.log(error);
                })
                .finally(() => {});
        },


        generatePageMeta() {
            let link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            link.setAttribute('href', 'https://www.helloromania.com/cazare-' + this.hotel.city.toLowerCase() + '/' + this.hotel.slug + '-' + this.hotel.id);
            document.head.appendChild(link);
        },

        appendAdditionalData(rawHotel) {
            if(!rawHotel) return {
                spanac: 1
            };
            return {
                rooms: rawHotel.best_offer.rooms,
                bestOffer: `${rawHotel.best_offer.price} ${rawHotel.best_offer.currency}`,
            };
        },

        navigateToHotel(hotelId) {
            let adults = 0;
            let occupancy = this.query.rooms.map(function (item) {
                adults += item.adults.length;
                let value = item.adults.map(adult => adult.age)
                    .concat(item.children.map(children => children.age));
                return value.join(",")
            })
            this.$router.push({
                name: 'hotel',
                query: {
                    place_id: this.query.place_id,
                    check_in: this.query.check_in,
                    check_out: this.query.check_out,
                    occupancy: occupancy,
                    currency: this.query.currency,

                },
                params: {
                    hotelId
                }
            })
        },

        goToReservation() {
            this.$router.push('/reservation');
        }

    }
}
</script>
